export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',md:12,ms:2,block:{md:2,xl:2,lg:2,ms:2}}}